<script setup lang="ts">
/*
 * Mirrors the Payroll prototype's .badge with .b-{ok|warn|info|muted|danger|paid}
 * variants — small rounded status indicator (11px text, 3px 10px padding).
 *
 * The "new" variant maps to the V6.0 prototype's .badge-new (uppercase,
 * heavier weight, smaller text — used for "NEW" feature tags in nav).
 */
type Variant = 'ok' | 'warn' | 'info' | 'muted' | 'danger' | 'paid' | 'new';

withDefaults(defineProps<{ variant?: Variant }>(), { variant: 'muted' });

const variants: Record<Variant, string> = {
  ok: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  warn: 'bg-amber-50 text-amber-700 border-amber-200',
  info: 'bg-primary-50 text-primary-700 border-primary-100',
  muted: 'bg-slate-100 text-slate-700 border-slate-200',
  danger: 'bg-red-50 text-red-700 border-red-200',
  paid: 'bg-violet-50 text-violet-700 border-violet-200',
  new: 'bg-pink-100 text-pink-700 border-transparent uppercase tracking-wider text-[9px] font-bold rounded-xs px-1 py-0.5',
};
</script>

<template>
  <span
    :class="[
      variant === 'new'
        ? variants.new
        : 'inline-flex items-center gap-1 rounded-pill border px-2.5 py-0.5 text-xs font-medium',
      variant !== 'new' ? variants[variant] : '',
    ]"
  >
    <slot />
  </span>
</template>
